import { RM11_04 } from "./RM11_04";

export const RM11_03 = {
  selectedValueColumn: "DrillKey",
  selectedTitle: "Territory",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "Territory",
        binding: {
          data: {
            columns: [
              {
                name: "Territory",
                columnName: "TerritoryName",
                width: "400px",
                align: "left",
                sortable: true
              },
              {
                name: "Agent Name",
                columnName: "AgentName",
                width: "400px",
                align: "left",
                sortable: true
              },
              {
                name: "Total Count",
                columnName: "TotalCount",
                width: "180px",
                align: "center",
                sortable: true
              },
            ],
            title: "AgentName",
            endpoint: "SFE_RM11.3",
            parameters: [
              { key: "CycleCode", value: "CP1" },
              { key: "CycleYear", value: "2026" },
              { key: "RegionCode", value: "" },
              { key: "DrillKey", value: "" },
            ],
          },
          context: {
            point: {
              onClick: RM11_04,
            },
          },
        },
      },
    },
  ],
};